import { AgentDockComponent } from './agent/components/agent-dock/agent-dock.component';
import { AgentClientService } from './agent/services/agent-client.service';
import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { AgentShellComponent } from './agent/components/agent-shell/agent-shell.component';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { environment } from '../environments/environment';
import { SharedService } from './services/shared.service';
import { AuthService } from './services/auth.service';
import { LoginResponse } from './interfaces/LoginResponse';

declare var process: {
  env: {
      API_URL: string,
      SAME_URL_AS_BACKEND: string
  }
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterModule,
    AgentShellComponent,
    AgentDockComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent{
  readonly agentAvailable = signal(false);
  private readonly agentClient = inject(AgentClientService);
  private readonly destroyRef = inject(DestroyRef);
  isLoading: boolean = true;

  refreshInterval: any;

  constructor(private router: Router, private shared: SharedService, private auth: AuthService){
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      const authenticated = this.router.routerState.root.firstChild?.snapshot.data['authenticated'] === true;
      this.agentAvailable.set(authenticated);
      if (!authenticated) this.agentClient.reset();
    });
    let isSameUrl = JSON.parse(process.env["SAME_URL_AS_BACKEND"]);
    if(isSameUrl){
      environment.API_URL = `${window.location.protocol}//${window.location.hostname}:8000`
    }
    // testing
    if(!this.shared.access_token && this.shared.refresh_token){
      this.refeshToken();
    }else{
      this.isLoading = false;
    }

    this.refreshInterval = setInterval(()=>{
      if(this.shared.refresh_token){
        this.refeshToken(false);
      }
    }, 5 * 60 * 1000)
  }

  refeshToken(navigate: boolean = true){
    if(navigate)this.isLoading = true;
    this.auth.renewToken().subscribe({
      next: (res: LoginResponse)=>{
        this.shared.access_token = res.result.token;
        this.shared.refresh_token = res.result.token_renew;
        if(res.result.user_attr) this.shared.user_attr = res.result.user_attr;
        this.isLoading = false;
        // if(navigate)this.router.navigate(["/"]);
      },
      error: (err)=>{
        this.isLoading = false;
        if(this.refreshInterval)clearInterval(this.refreshInterval);
        this.router.navigate(["/login"]);
      }
    });
  }

  version = environment.version;
}
